// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3gh9_","colMaxWidth":"Table_colMaxWidth__3oxuB"};